<div class="cont-main">
    <div class="cont-checkbox" *ngFor="let iOption of options; index as i">
        <input
            type="checkbox"
            [id]="'myCheckbox-' + i"
            [ngModel]="selections.isSelected(iOption)"
            (ngModelChange)="onSelectionChange($event, iOption)"
        />
        <label [for]="'myCheckbox-' + i">
            <ng-container *ngIf="iOption.fileType !== 'image'; else imageTmpl">
                <div class="file-preview">
                    <span class="file-preview__type">{{ iOption.fileTypeLabel || 'FILE' }}</span>
                    <a
                        class="file-preview__name"
                        [href]="iOption.fileUrl"
                        target="_blank"
                        rel="noopener noreferrer"
                        title="打开附件"
                        (click)="$event.stopPropagation()"
                    >
                        {{ iOption.fileName || 'Attachment' }}
                    </a>
                </div>
            </ng-container>
            <ng-template #imageTmpl>
                <img [src]="iOption.fileUrl" />
            </ng-template>
            <span class="cover-checkbox">
                <svg viewBox="0 0 12 10">
                    <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                </svg>
            </span>
            <div class="info"></div>
        </label>
    </div>
</div>
